// Central place for brand contact + config. Easy to swap for API values later.
export const BRAND = {
  name: "BathLane",
  tagline: "Premium vanity buying, made simple.",
  email: "support@bathlane.in",
  phoneDisplay: "+91 90015 09191",
  phoneRaw: "919001509191",
};

export const WHATSAPP_URL = (msg = "Hi BathLane, I'd like help choosing a vanity.") =>
  `https://wa.me/${BRAND.phoneRaw}?text=${encodeURIComponent(msg)}`;

export const MAILTO = `mailto:${BRAND.email}`;
